import { memo, useState } from 'react'
import { UserContext } from 'contexts/UserContext'
import { reactLocalStorage } from 'reactjs-localstorage'

const AuthProvider = ({ children }) => {
  const dataUser = reactLocalStorage.getObject('var')
  const [user, setUser] = useState(dataUser ? dataUser : null)

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  )
}

export default memo(AuthProvider)
